import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, CircularProgress } from '@metarouter-private/mr-mui';

export default function ExportProgress({ current, total }) {
  return (
    <Stack spacing={2} alignItems="center" padding={3}>
      <CircularProgress />
      <Typography variant="body1">
        Exporting schema {current + 1} of {total}...
      </Typography>
    </Stack>
  );
}

ExportProgress.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};
